<div class="ui-sidebar-brand" [class.ui-sidebar-brand--collapsed]="collapsed">
  <div class="ui-sidebar-brand__logo">{{ logoText }}</div>
  <div class="ui-sidebar-brand__text" *ngIf="!collapsed">
    <div class="ui-sidebar-brand__company">{{ companyName }}</div>
    <div class="ui-sidebar-brand__app">{{ appName }}</div>
  </div>
</div>
